const SHARED_SESSION_ID_KEY = 'store_session_id';
const LEGACY_CHAT_SESSION_ID_KEY = 'ai_chat_session_id';

function safeLocalStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function safeSessionStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function getSharedSessionId() {
  const persistentStorage = safeLocalStorage();
  const sessionStorage = safeSessionStorage();
  if (!persistentStorage && !sessionStorage) return 'server-render-session';

  // Messenger cart claims are one-time handoffs into this session identity.
  // Keep the shared storefront session persistent across tabs/browser restarts so
  // a claimed cart does not get stranded in a short-lived sessionStorage owner.
  let id =
    persistentStorage?.getItem(SHARED_SESSION_ID_KEY)
    ?? persistentStorage?.getItem(LEGACY_CHAT_SESSION_ID_KEY)
    ?? sessionStorage?.getItem(SHARED_SESSION_ID_KEY)
    ?? sessionStorage?.getItem(LEGACY_CHAT_SESSION_ID_KEY);
  if (!id) {
    id = globalThis.crypto?.randomUUID?.()
      ?? `sess-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  }

  persistentStorage?.setItem(SHARED_SESSION_ID_KEY, id);
  persistentStorage?.setItem(LEGACY_CHAT_SESSION_ID_KEY, id);
  sessionStorage?.setItem(SHARED_SESSION_ID_KEY, id);
  sessionStorage?.setItem(LEGACY_CHAT_SESSION_ID_KEY, id);
  return id;
}
